import type { Editor, SelectOption } from 'grapesjs';

import { type IBlockContent } from '../../interfaces';

export const documentLinkId = 'document-link';
export const documentLinkType = 'document-link';
export const documentLinkContainerType = `${documentLinkType}-container`;

const DocumentLinkPlugin = (
  editor: Editor,
  selectOption: SelectOption[]
): void => {
  editor.DomComponents.addType(documentLinkType, {
    extend: 'link',
    isComponent: (el) =>
      el.attributes?.getNamedItem('custom-type')?.value === documentLinkType,
    model: {
      defaults: {
        attributes: {
          'custom-type': documentLinkType,
        },
        tagName: 'a',
        traits: [
          'title',
          {
            type: 'select',
            name: 'href',
            options: selectOption,
          },
          {
            type: 'select',
            label: 'Target',
            name: 'target',
            default: '_blank',
            options: [
              { id: '_blank', name: 'New window' },
              { id: 'false', name: 'This window' },
            ],
          },
        ],
        name: 'Document Link',
      },
    },
  });

  editor.DomComponents.addType(documentLinkContainerType, {
    extend: 'default',
    isComponent: (el) =>
      el.attributes?.getNamedItem('custom-type')?.value ===
      documentLinkContainerType,
    model: {
      defaults: {
        attributes: {
          'custom-type': documentLinkContainerType,
        },
        tagName: 'div',
        name: 'Document Link Container',
      },
    },
  });

  const DocumentLinkContent: IBlockContent = {
    attributes: { class: 'link-document' },
    content: 'Link to document',
    editable: true,
    type: documentLinkType,
  };

  const CenterContainer: IBlockContent = {
    components: DocumentLinkContent,
    editable: true,
    style: { 'text-align': 'center', width: '100%' },
    type: documentLinkContainerType,
  };

  editor.BlockManager.add(documentLinkId, {
    label: 'Document Link',
    category: 'Basic',
    content: CenterContainer,
    media:
      '<svg\n   viewBox="0 0 20.55374 20.780001"\n   version="1.1"\n   id="svg5"\n   sodipodi:docname="bitmap.svg"\n   inkscape:export-filename="bitmap(doc_link).svg"\n   inkscape:export-xdpi="110.88215"\n   inkscape:export-ydpi="110.88215"\n   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"\n   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:svg="http://www.w3.org/2000/svg">\n  <sodipodi:namedview\n     id="namedview8"\n     pagecolor="#ffffff"\n     bordercolor="#000000"\n     borderopacity="0.25"\n     inkscape:showpageshadow="2"\n     inkscape:pageopacity="0.0"\n     inkscape:pagecheckerboard="0"\n     inkscape:deskcolor="#d1d1d1"\n     showgrid="false" />\n  <defs\n     id="defs2" />\n  <path\n     id="path239"\n     style="stroke-width:0.9"\n     d="m 1.7988282,2.3741562 c -0.98999805,0 -1.79101575,0.8107833 -1.79101575,1.8007813 L 2.45e-6,14.975719 c 0,0.989997 0.8088301,1.798828 1.79882805,1.798828 h 9.6406245 c -0.04984,-0.194949 -0.07617,-0.399148 -0.07617,-0.609375 0,-0.431289 0.112862,-0.836161 0.308594,-1.189453 H 1.7988282 V 4.1749375 h 4.6542969 l 1.7988282,1.8007813 h 7.9472647 v 8.6308592 h 0.0957 v -0.683594 a 0.22417392,0.22417392 0 0 1 0.224609,-0.224609 h 1.480469 V 5.9757188 c 0,-0.9899982 -0.810782,-1.8007813 -1.800782,-1.8007813 H 9.0000002 L 7.1992182,2.3741562 Z M 16.74414,14.147594 v 0.402344 H 18 v -0.402344 z" />\n  <g\n     id="layer1-7"\n     transform="translate(-3.3930572,0.95798299)"\n     style="display:inline;stroke:none;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1">\n    <g\n       id="path195-8-5">\n      <path\n         style="color:currentColor;fill:currentColor;stroke:none;stroke-width:0.448303;-inkscape-stroke:none"\n         d="m 15.832518,15.206238 c 0,-0.766598 0.62314,-1.389739 1.389738,-1.389739 h 1.793211 v -0.851775 h -1.793211 a 2.2415133,2.2415133 0 0 0 -2.241513,2.241514 2.2415133,2.2415133 0 0 0 2.241513,2.241513 h 1.793211 v -0.851775 h -1.793211 c -0.766598,0 -1.389738,-0.623141 -1.389738,-1.389738 m 1.838041,0.448302 h 3.586421 v -0.896605 h -3.586421 v 0.896605 m 4.034724,-2.689816 h -1.793211 v 0.851775 h 1.793211 c 0.766597,0 1.389738,0.623141 1.389738,1.389739 0,0.766597 -0.623141,1.389738 -1.389738,1.389738 h -1.793211 v 0.851775 h 1.793211 a 2.2415133,2.2415133 0 0 0 2.241513,-2.241513 2.2415133,2.2415133 0 0 0 -2.241513,-2.241514 z"\n         id="path3802" />\n    </g>\n  </g>\n</svg>',
    select: true,
  });
};

export default DocumentLinkPlugin;
